module.exports = __webpack_public_path__ + "img/visa.30fafd6f.svg";